module.exports = __webpack_public_path__ + "static/img/Banner Main@2x.fb6eef18.png";